<template>
  <div>
    <el-row>
      <el-col class="title-admin">
        {{mainTitle}}
      </el-col>
    </el-row>
    <div v-for="(content,index) in contents" :key="index">
      <el-row class="primaryTitle" v-if="content.type === 'primaryTitle'">
        <!--熊猫图标-->
        <el-col :span="2">
          <img class="icon" :src="iconImage" alt="">
        </el-col>
        <!--title-->
        <el-col :span="22">
          <p class="title">{{content.text}}</p>
        </el-col>
      </el-row>

      <el-row v-else-if="content.type === 'text'">
        <el-col>
          <p class="demo-text" v-html="content.text"></p>
        </el-col>
      </el-row>
      <el-row v-else-if="content.type === 'text2'">
        <el-col>
          <p class="demo-text2" v-html="content.text"></p>
        </el-col>
      </el-row>

      <el-row v-else-if="content.type === 'author'">
        <el-col>
          <p class="author-text2" v-html="content.text"></p>
        </el-col>
      </el-row>

      <el-row v-else-if="content.type === 'secondaryBlack'">
        <el-col class="secondaryTitle">
          <p class="secondaryBlack" v-html="content.text"></p>
        </el-col>
      </el-row>
      <el-row v-else-if="content.type === 'secondaryTitle2'">
        <el-col class="secondaryTitle2">
          <p class="secondaryTitle2" v-html="content.text"></p>
        </el-col>
      </el-row>


      <el-row v-else-if="content.type === 'secondaryTitle'">
        <el-col class="secondaryTitle3">
          <p v-html="content.text"></p>
        </el-col>
      </el-row>

      <el-row v-else-if="content.type === 'noList'">
        <el-col>
          <li class="noList">
            <div  v-html="content.text"></div>
          </li>
        </el-col>
      </el-row>

      <el-row v-else-if="content.type === 'retract'">
        <el-col class="retract">
          <li class="noList">
            <div  v-html="content.text"></div>
          </li>
        </el-col>
      </el-row>
      <el-row v-else-if="content.type === 'noListBlack'">
        <el-col>
          <li class="noList black-text">
            <div  v-html="content.text"></div>
          </li>
        </el-col>
      </el-row>

      <el-row v-else-if="content.type === 'retractBlack'">
        <el-col class="retract">
          <li class="noList black-text">
            <div v-html="content.text"></div>
          </li>
        </el-col>
      </el-row>

      <el-row v-else-if="content.type === 'retract2'">
        <el-col class="retract2">
          <li class="noList">
            <div v-html="content.text"></div>
          </li>
        </el-col>
      </el-row>

      <el-row v-else-if="content.type === 'retract2Black'">
        <el-col class="retract2">
          <li class="noList black-text">
            <div v-html="content.text"></div>
          </li>
        </el-col>
      </el-row>

      <el-row v-else-if="content.type === 'textBlue'">
        <el-col>
          <p class="textBlue" v-html="content.text"></p>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "awards",
  data() {
    return {
      iconImage: require("@/assets/content/sy_icon_xm.png"),
      mainTitle: 'Awards',
      contents:[
      // {
      //     type:'primaryTitle',
      //     text:'Conference Awards'
      //   },
        // {
        //   type:'primaryTitle',
        //   text:'Best Paper Award'
        // },
        // {
        //   type:'secondaryTitle',
        //   text:'<b>Speech2AffectiveGestures: Synthesizing Co-Speech Gestures with Generative Adversarial Affective Expression Learning</b>'
        // },
        // {
        //   type:'text',
        //   text:''
        // },
        // {
        //   type:'author',
        //   text:'Uttaran Bhattacharya*'
        // },
        // { 
        //   type:'author',
        //   text:'Elizabeth Childs'
        // },
        // {
        //   type:'author',
        //   text:'Nicholas S Rewkowski'
        // },
        // {
        //   type:'author',
        //   text:' Dinesh Manocha'
        // },
        // // {
        // //   type:'author',
        // //   text:'Uttaran Bhattacharya (University of Maryland, College Park)*'
        // // },
        // // { 
        // //   type:'author',
        // //   text:'Elizabeth Childs (University of Maryland, College Park)'
        // // },
        // // {
        // //   type:'author',
        // //   text:'Nicholas S Rewkowski (UMD College Park)'
        // // },
        // // {
        // //   type:'author',
        // //   text:' Dinesh Manocha (University of Maryland at College Park)'
        // // },

        // // {
        // //   type:'primaryTitle',
        // //   text:'Best Student Paper Award'
        // // },
        // {
        //   type:'secondaryTitle',
        //   text:'<b>Video Background Music Generation with Controllable Music Transformer</b>'
        // },
        // {
        //   type:'text',
        //   text:''
        // },
        //  {
        //   type:'author',
        //   text:'Shangzhe Di'
        // },
        // {
        //   type:'author',
        //   text:'Zeren Jiang'
        // },
        // {
        //   type:'author',
        //   text:'Si Liu*'
        // },
        // {
        //   type:'author',
        //   text:'Zhaokai Wang'
        // },
        // {
        //   type:'author',
        //   text:'Leyan Zhu'
        // },
        // {
        //   type:'author',
        //   text:'Zexin He'
        // },
        // {
        //   type:'author',
        //   text:'Hongming Liu'
        // },
        // {
        //   type:'author',
        //   text:'Shuicheng Yan'
        // },
        // // {
        // //   type:'author',
        // //   text:'Shangzhe Di (Beihang University)'
        // // },
        // // {
        // //   type:'author',
        // //   text:'Zeren Jiang (Megvii)'
        // // },
        // // {
        // //   type:'author',
        // //   text:'Si Liu (Beihang University)*'
        // // },
        // // {
        // //   type:'author',
        // //   text:'Zhaokai Wang (beihang university)'
        // // },
        // // {
        // //   type:'author',
        // //   text:'Leyan Zhu (Beihang University)'
        // // },
        // // {
        // //   type:'author',
        // //   text:'Zexin He (Beihang University)'
        // // },
        // // {
        // //   type:'author',
        // //   text:'Hongming Liu (Sea AI Labs)'
        // // },
        // // {
        // //   type:'author',
        // //   text:'Shuicheng Yan (Sea AI Labs)'
        // // },

        // {
        //   type:'secondaryTitle',
        //   text:'<b>PIMNet: A Parallel, Iterative and Mimicking Network for Scene Text Recognition</b>'
        // },
        // {
        //   type:'text',
        //   text:''
        // },
        //         {
        //   type:'author',
        //   text:'Zhi Qiao'
        // },
        // {
        //   type:'author',
        //   text:'Yu Zhou*'
        // },
        // {
        //   type:'author',
        //   text:'Jin Wei'
        // },
        // {
        //   type:'author',
        //   text:'Wei Wang'
        // },
        // {
        //   type:'author',
        //   text:'Yuan Zhang'
        // },
        // {
        //   type:'author',
        //   text:'Ning Jiang'
        // },
        // {
        //   type:'author',
        //   text:'Hongbin Wang'
        // },
        // {
        //   type:'author',
        //   text:'Weiping Wang'
        // },
        // // {
        // //   type:'author',
        // //   text:'Zhi Qiao (Institute of Information Engineering, Chinese Academy of Sciences)'
        // // },
        // // {
        // //   type:'author',
        // //   text:'Yu Zhou (Institute of Information Engineering, CAS; Also with University of Chinese Academy of Sciences)*'
        // // },
        // // {
        // //   type:'author',
        // //   text:'Jin Wei (School of Information and Communication Engineering, Communication University of China)'
        // // },
        // // {
        // //   type:'author',
        // //   text:'Wei Wang (Institute of Information Engineering, Chinese Academy of Sciences; School of Cyber Security, University of Chinese Academy of Sciences)'
        // // },
        // // {
        // //   type:'author',
        // //   text:'Yuan Zhang (Communication University of China)'
        // // },
        // // {
        // //   type:'author',
        // //   text:'Ning Jiang (Mashang Consumer Finance Co., Ltd.)'
        // // },
        // // {
        // //   type:'author',
        // //   text:'Hongbin Wang (Mashang Consumer Finance Co., Ltd)'
        // // },
        // // {
        // //   type:'author',
        // //   text:'Weiping Wang (Institute of Information Engineering, CAS, China)'
        // // },
        
        // {
        //   type:'secondaryTitle',
        //   text:'<b>Theophany: Multimodal Speech Augmentation in Instantaneous Privacy Channels</b>'
        // },
        // {
        //   type:'text',
        //   text:''
        // },
        // {
        //   type:'author',
        //   text:'Abhishek Kumar*'
        // },
        // {
        //   type:'author',
        //   text:'Tristan Braud'
        // },
        // {
        //   type:'author',
        //   text:'Lik Hang Lee'
        // },
        // {
        //   type:'author',
        //   text:'Pan Hui'
        // },
        // // {
        // //   type:'author',
        // //   text:'Abhishek Kumar (University of Helsinki)*'
        // // },
        // // {
        // //   type:'author',
        // //   text:'Tristan Braud (HKUST)'
        // // },
        // // {
        // //   type:'author',
        // //   text:'Lik Hang Lee (KAIST)'
        // // },
        // // {
        // //   type:'author',
        // //   text:'Pan Hui (Hong Kong University of Science and Technology)'
        // // },


        // {
        //   type:'secondaryTitle',
        //   text:'<b>aBio: Active Bi-Olfactory Display Using Subwoofers for Virtual Reality</b>'
        // },
        // {
        //   type:'text',
        //   text:''
        // },
        // {
        //   type:'author',
        //   text:'You-Yang Hu*'
        // },
        // {
        //   type:'author',
        //   text:'Yao-Fu Jan'
        // },
        // {
        //   type:'author',
        //   text:'Kuan-Wei Tseng'
        // },
        // {
        //   type:'author',
        //   text:'You-Shin Tsai'
        // },
        // {
        //   type:'author',
        //   text:'Hung-Ming Sung'
        // },
        // {
        //   type:'author',
        //   text:'Jin-Yao Lin'
        // },
        // {
        //   type:'author',
        //   text:'Yi-Ping Hung'
        // },
        // // {
        // //   type:'author',
        // //   text:'You-Yang Hu (NTU)*'
        // // },
        // // {
        // //   type:'author',
        // //   text:'Yao-Fu Jan (NTU)'
        // // },
        // // {
        // //   type:'author',
        // //   text:'Kuan-Wei Tseng (NTU)'
        // // },
        // // {
        // //   type:'author',
        // //   text:'You-Shin Tsai (NTU)'
        // // },
        // // {
        // //   type:'author',
        // //   text:'Hung-Ming Sung (NTU)'
        // // },
        // // {
        // //   type:'author',
        // //   text:'Jin-Yao Lin (Tainan National University of the Arts)'
        // // },
        // // {
        // //   type:'author',
        // //   text:'Yi-Ping Hung (NTU)'
        // // },




        // // {
        // //   type:'primaryTitle',
        // //   text:'ACM SIGMM 2021 Awards'
        // // },
        // // {
        // //   type:'secondaryTitle',
        // //   text:'<b></b>'
        // // },
        // // {
        // //   type:'text',
        // //   text:''
        // // },
        // // {
        // //   type:'author',
        // //   text:''
        // // },



        {
          type:'primaryTitle',
          text:'SIGMM Outstanding Technical Achievement Award'
        },
        {
          type:'secondaryTitle2',
          text:'<b>Jiebo Luo</b> (University of Rochester, USA)'
        },
        {
          type:'text',
          text:''
        },
        {
          type:'author',
          text:''
        },


        {
          type:'primaryTitle',
          text:'SIGMM Rising Star Award'
        },
        {
          type:'secondaryTitle2',
          text:'<b>Jingkuan Song</b> (University of Electronic Science and Technology of China, China)'
        },
        {
          type:'text',
          text:''
        },
        {
          type:'author',
          text:''
        },


        {
          type:'primaryTitle',
          text:'SIGMM Test of Time Paper Award'
        },
        {
          type:'secondaryTitle',
          text:"<b>Dynamic Adaptive Streaming over HTTP ‐ Standards and Design Principle</b> "
        },
        {
          type:'text2',
          text:"In Proceedings of the 2nd ACM Conference on Multimedia Systems, MMSys'11, pp. 133‐144, 2011."
        },
        {
          type:'secondaryTitle2',
          text:'<b>Thomas Stockhammer</b> (Qualcomm Inc., Germany)'
        },



        {
          type:'primaryTitle',
          text:'SIGMM Outstanding PhD Thesis Award'
        },
        {
          type:'secondaryTitle',
          text:'<b>Video Adaption for High Quality Content Deliver</b>'
        },
        // {
        //   type:'text',
        //   text:''
        // },
        {
          type:'secondaryTitle2',
          text:'<b>Kevin Spiteri</b> (University of Massachusetts Amherst, USA)'
        },




      ],
    }
  },
  mounted() {
    document.title = 'ACM Multimedia 2021 Awards'
  }
}

</script>

<style scoped>
@import "../../css/responsive.css";
</style>